var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',[_c('template',{slot:"header"},[_c('div',[_c('span',[_vm._v("财务开票信息")])])]),_vm._v(" "),(_vm.type == 'show')?_c('ly-information',{staticClass:"mt15",attrs:{"config":_vm.infoConfig,"data":_vm.info}}):_c('Ly-search-form',{ref:"searchForm",attrs:{"config":_vm.formConfig,"rules":_vm.formRules,"is-search":false,"label-width":"120px"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }